import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import { withErrorBoundary } from '@sentry/react';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import DataTable from '../../components/dataTable/DataTable';
import ViewHeader from '../../components/header/ViewHeader';
import Button from '../../components/form/Button';
import { joinDefined, PAGE_STOCK, prettyPrice } from '../../utils/strings';
import ErrorFallback from '../../components/ErrorFallback';
import defaultImage from '../../assets/default-image.png';
import { CloseIcon } from '../../components/IconIndex';
import GatedComponent from '../../components/GatedComponent';

class StockList extends Component {
    render() {
        const { history } = this.props;
        return (
            <Grid container className="sticky-table">
                <Grid item>
                    <ViewHeader title="Catalogue">
                        <GatedComponent canEditCode={'CMS_ACCESS_SilverShop\\Admin\\ProductCatalogAdmin'}>
                            {() => (
                                <Button
                                    style={{ float: 'right' }}
                                    variant="primary icon-button white shadow"
                                    size="lg"
                                    title="Add a new catalogue item"
                                    onClick={() => history.push('0')}
                                >
                                    <CloseIcon style={{ transform: 'rotate(45deg)' }} />
                                </Button>
                            )}
                        </GatedComponent>
                    </ViewHeader>
                </Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid item>{this.renderTable()}</Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    renderTable() {
        return (
            <Fragment>
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <DataTable
                                dataObject="CMProduct"
                                queryName="readCMProducts"
                                fragment={stockFragment}
                                // isFilterable
                                // isSortable
                                columns={tableColumns}
                                variables={{
                                    filters: [{ field: 'AllowPurchase', value: '1' }],
                                    filterBy: [],
                                    sortBy: [{ field: 'InternalItemID', direction: 'ASC' }]
                                }}
                                searchVariable="contains"
                                noFiltersTitle="All Products & Services"
                                // showFlags
                                persistVariablesKey="Stock"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

export const tableColumns = [
    {
        label: 'Code/SKU',
        propertyPath: 'InternalItemID',
        renderCell: (row, value) =>
            <Button href={PAGE_STOCK + row.ID} variant="link-orange">
                {value || row.ID}
            </Button>
    },
    {
        label: 'Photo',
        tiny: true,
        className: 'td--not-padded align-center',
        propertyPath: 'ImageURL',
        renderCell: (row, value) => <img
            src={value || defaultImage} width={48} height={48} alt="Product thumbnail"
            style={{ objectFit: 'contain', objectPosition: 'center', verticalAlign: 'middle' }}
        />
    },
    {
        label: 'Title',
        propertyPath: 'Title'
    },
    {
        label: 'Description',
        propertyPath: 'ContentSummary',
        renderCell: (row, value) => <>{value || ''}</>
    },
    {
        label: 'Categories',
        propertyPath: 'Parent',
        renderCell: (row, value) => {
            const vals = row.ProductCategories.map(obj => obj.Title) || [];
            vals.unshift(value.Title);
            return joinDefined(vals, ', ');
        }
    },
    {
        label: 'Sale Price',
        propertyPath: 'SellingPrice',
        className: 'align-right',
        renderCell: (row, value) => prettyPrice(value)
    },
    {
        label: 'Wholesale Price',
        propertyPath: 'PriceOverrides',
        className: 'align-right',
        renderCell: (row, value) => {
            const { _join } = value.nodes[0] || {};
            const { PriceOverride } = _join || {};
            return PriceOverride ? prettyPrice(PriceOverride.SellingPrice) : '-';
        }
    }
];

export const stockFragment = gql`
    fragment StockRecord on CMProduct {
        ID
        InternalItemID
        Title
        ContentSummary
        SellingPrice
        ImageURL
        Parent {
            ID
            Title
        }
        ProductCategories {
            ID
            Title
        }
        PriceOverrides {
            nodes {
                ID
                ... on OfficesUsername {
                    _join {
                        PriceOverride {
                            ID
                            SellingPrice
                        }
                    }
                }
            }
        }
        Variations {
            nodes {
                ID
            }
        }
    }
`;

export default withErrorBoundary(compose(withRouter, withStyles({}))(StockList), { fallback: ErrorFallback });
